import type { QueryClient } from "@tanstack/react-query";

import { player } from "@src/services/player";
import { DEFAULT_TRACK_ID } from "@src/services/player/constants";

import { setupOnlineMode } from "@src/utils/online/setupOnlineMode";

const MAX_ATTEMPTS = 3;

/**
 * Tenta tocar a faixa online (DEFAULT_TRACK_ID).
 * Se a track ainda não existir (race condition entre removeTrack/addTrack),
 * recria o modo online e tenta novamente após 500ms, até MAX_ATTEMPTS vezes.
 * Ao esgotar as tentativas, chama onMaxAttempts (ex: entrar no modo offline).
 */
export function safePlayOnline(
  queryClient: QueryClient,
  onMaxAttempts?: () => void,
  attempt = 1,
) {
  try {
    player.play(DEFAULT_TRACK_ID);
  } catch (error) {
    if (
      error instanceof Error &&
      error.message.match(/Track ID radio does not exist/i)
    ) {
      if (attempt >= MAX_ATTEMPTS) {
        console.warn(
          `[safePlayOnline] Falhou após ${MAX_ATTEMPTS} tentativas.`,
        );
        onMaxAttempts?.();
        return;
      }
      console.warn(
        `[safePlayOnline] Tentativa ${attempt}/${MAX_ATTEMPTS} falhou, tentando novamente...`,
      );
      setTimeout(() => {
        setupOnlineMode(queryClient);
        safePlayOnline(queryClient, onMaxAttempts, attempt + 1);
      }, 500);
    } else {
      throw error;
    }
  }
}
